import { render, staticRenderFns } from "./Designer.vue?vue&type=template&id=24bd7038&"
import script from "./Designer.vue?vue&type=script&lang=js&"
export * from "./Designer.vue?vue&type=script&lang=js&"
import style0 from "./Designer.vue?vue&type=style&index=0&id=24bd7038&prod&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports